import { MisbilledRecord } from "../types/Records";

import { MisbilledTradeState } from "../types";
import { INITIAL_MISBILLED_TRADES_STATE } from "../containers/contexts/search/SearchContext";
import {
  GET_MISBILLED_TRADES,
  GET_MISBILLED_TRADES_FAILURE,
  GET_MISBILLED_TRADES_SUCCESS,
} from "../actions";

export const misbilledTradesReducer = (
  state: MisbilledTradeState = INITIAL_MISBILLED_TRADES_STATE,
  action: {
    type: string;
    records?: MisbilledRecord[];
  }
) => {
  const { type, records } = action;
  switch (type) {
    case GET_MISBILLED_TRADES:
      return {
        ...state,
        ...INITIAL_MISBILLED_TRADES_STATE,
        loadingMisbilledTrades: true,
      };
    case GET_MISBILLED_TRADES_SUCCESS:
      return {
        ...state,
        loadingMisbilledTrades: false,
        records,
      };
    case GET_MISBILLED_TRADES_FAILURE:
      return { ...state, loadingMisbilledTrades: false };
    default:
      return state;
  }
};
